import { CookieBanner } from './cookies';
import { RealmSelectorContainer } from './RealmSelectorContainer';
import { AppTheme } from './theme';

export const App: React.FC = () => {
    return (
        <AppTheme stylesInject={true} themeMode="light">
            {/* Rendered first so the consent banner, which the cookie manager styles as
                sticky to the top, sits above the page rather than after it. */}
            <CookieBanner />
            <RealmSelectorContainer />
        </AppTheme>
    );
};

export default App;
